import logo from "./logo.svg";
import "./App.css";
import Main from "./Main";
import { useEffect, useMemo } from "react";
function App() {
  useMemo(() => {
    localStorage.removeItem('last_conversation_id')
  }, []);
  return <Main />;
}

export default App;
